/* ==================================================================
   North Shore Peptides — Product page
   Gallery · quantity stepper · variant selection
   ================================================================== */
(function () {
  'use strict';

  function initProduct(root) {
    if (!root || root.dataset.npInit === 'true') return;
    root.dataset.npInit = 'true';

    /* ---------- Gallery ---------- */
    var mainImg = root.querySelector('[data-gallery-main]');
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-gallery-thumb]'));
    function setMain(src, srcset, thumbEl) {
      if (!mainImg || !src) return;
      mainImg.src = src;
      if (srcset) mainImg.srcset = srcset; else mainImg.removeAttribute('srcset');
      thumbs.forEach(function (t) { t.setAttribute('aria-current', t === thumbEl ? 'true' : 'false'); });
    }
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        setMain(thumb.dataset.full, thumb.dataset.fullSrcset, thumb);
      });
    });

    /* ---------- Quantity ---------- */
    var qtyWrap = root.querySelector('.np-qty');
    if (qtyWrap) {
      var input = qtyWrap.querySelector('input');
      qtyWrap.querySelectorAll('button[data-qty]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var v = parseInt(input.value, 10) || 1;
          v = btn.dataset.qty === 'plus' ? v + 1 : Math.max(1, v - 1);
          input.value = v;
        });
      });
    }

    /* ---------- Variants ---------- */
    var dataEl = root.querySelector('[data-np-variants]');
    if (!dataEl) return;
    var variants;
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }

    var optionInputs = Array.prototype.slice.call(root.querySelectorAll('[data-option-index]'));
    var idInput = root.querySelector('[data-variant-id]');
    var priceEl = root.querySelector('[data-price]');
    var atcBtn = root.querySelector('[data-atc]');
    var atcText = atcBtn && atcBtn.querySelector('.np-btn__label');
    var optionByIndex = {};

    optionInputs.forEach(function (inp) {
      inp.addEventListener('change', onChange);
    });

    function selectedOptions() {
      var sel = [];
      optionInputs.forEach(function (inp) {
        if (inp.checked) sel[parseInt(inp.dataset.optionIndex, 10)] = inp.value;
      });
      return sel;
    }

    function findVariant(sel) {
      return variants.find(function (v) {
        return v.options.every(function (opt, i) { return opt === sel[i]; });
      });
    }

    function onChange() {
      var sel = selectedOptions();
      var variant = findVariant(sel);

      if (!variant) {
        if (atcBtn) { atcBtn.setAttribute('disabled', ''); }
        if (atcText) atcText.textContent = atcBtn.dataset.unavailable || 'Unavailable';
        return;
      }

      // hidden id
      if (idInput) idInput.value = variant.id;

      // url
      try {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      } catch (e) {}

      // price
      if (priceEl) {
        var html = '<span>' + variant.price + '</span>';
        if (variant.on_sale && variant.compare) html += '<s class="was">' + variant.compare + '</s>';
        priceEl.innerHTML = html;
        priceEl.classList.toggle('np-product__price--sale', !!variant.on_sale);
      }

      // availability
      if (atcBtn && atcText) {
        if (variant.available) {
          atcBtn.removeAttribute('disabled');
          atcText.textContent = atcBtn.dataset.addLabel || 'Add to cart';
        } else {
          atcBtn.setAttribute('disabled', '');
          atcText.textContent = atcBtn.dataset.soldout || 'Sold out';
        }
      }

      // image
      if (variant.image && mainImg) {
        var match = thumbs.find(function (t) { return t.dataset.mediaId === String(variant.media_id); });
        setMain(variant.image, match ? match.dataset.fullSrcset : null, match || null);
      }
    }
  }

  function initAll() { document.querySelectorAll('.np-product').forEach(initProduct); }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();

  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target.querySelector('.np-product');
    if (el) { el.dataset.npInit = ''; initProduct(el); }
  });
})();
